import React from 'react'
import styled from 'styled-components'
import CheckIconImg from '../../images/checkIcon.svg'

export const CheckIcon: React.FC = () => <StyledCheckIcon src={CheckIconImg} />

const StyledCheckIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 4px;
`
